import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router";
import {LANDING, LOGIN} from "../../constants/ROUTER_PATH_TITLE";
import useTranslate from "../../hooks/useTranslate";
import { removeLocalStorageToken } from "../../App/AppWrapper/localStorages";
import useAuth from "../../hooks/useAuth";
import { SocialLoginSignoutPage } from "@tripian/react";

const SocialLoginSignout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslate();
  const { logout } = useAuth();
  const [remainingSeconds, setRemainingSeconds] = useState(0);
  useEffect(() => {
    removeLocalStorageToken();
    logout();
    window.tconfig.SOCIAL_LOGIN = false;

    const countdownInterval = setInterval(() => {
      setRemainingSeconds(prev => Math.max(0, prev - 1));
    }, 1000);

    const timer = setTimeout(() => {
      if (window.tconfig.SHOW_LANDING_PAGE) {
        navigate(LANDING.PATH, { replace: true });
      } else {
        navigate(LOGIN.PATH, { replace: true });
      }
    }, 0);

    return () => {
      clearInterval(countdownInterval);
      clearTimeout(timer);
    };
  }, [navigate, location, logout]);

  return (
      <SocialLoginSignoutPage
          t={t}
          remainingSeconds={remainingSeconds}
      />
  );
};

export default SocialLoginSignout;